/* compare.js - BikeHubUSA compare selection (theme-update friendly)
   - Looks for checkboxes with: .bh-compare-checkbox and data-bh-handle="product-handle"
   - Stores selection in localStorage so it persists
   - Updates any link to /pages/compare-e-bikes to include ?compare=...
   - On the compare page, hides/shows table columns client-side (works even if Shopify caches HTML)
*/

(function () {
  const STORAGE_KEY = "bh_compare_handles_v1";
  const COMPARE_PATH = "/pages/compare-e-bikes";
  const MAX = 6;

  const qs = (sel, root = document) => root.querySelector(sel);
  const qsa = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  function loadSelected() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      const arr = JSON.parse(raw);
      if (!Array.isArray(arr)) return [];
      return arr.map((x) => String(x || "").trim().toLowerCase()).filter(Boolean);
    } catch (e) {
      return [];
    }
  }

  function saveSelected(handles) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    } catch (e) {}
  }

  function addHandle(handles, h) {
    if (!h) return handles;
    if (handles.includes(h)) return handles;
    if (handles.length >= MAX) return handles;
    return handles.concat(h);
  }

  function removeHandle(handles, h) {
    return handles.filter((x) => x !== h);
  }

  function buildCompareUrl(handles) {
    const clean = (handles || []).filter(Boolean);
    if (!clean.length) return COMPARE_PATH;
    // Keep commas unescaped in the actual URL string for readability,
    // but it is fine if the browser encodes them.
    return `${COMPARE_PATH}?compare=${encodeURIComponent(clean.join(","))}`;
  }

  function setCompareLinkHref(handles) {
    const url = buildCompareUrl(handles);
    const links = qsa(`a[href="${COMPARE_PATH}"], a[href^="${COMPARE_PATH}?"]`);
    links.forEach((a) => a.setAttribute("href", url));
    window.__bhCompareUrl = url;
  }

  function syncCheckboxes(handles) {
    const boxes = qsa(".bh-compare-checkbox[data-bh-handle]");
    boxes.forEach((cb) => {
      const h = (cb.getAttribute("data-bh-handle") || "").toLowerCase();
      cb.checked = handles.includes(h);
    });
  }

  function ensureBar() {
    let bar = qs("#bh-compare-bar");
    if (bar) return bar;

    bar = document.createElement("div");
    bar.id = "bh-compare-bar";
    bar.style.cssText =
      "position:fixed;left:16px;right:16px;bottom:16px;z-index:9999;" +
      "display:none;align-items:center;justify-content:space-between;gap:12px;" +
      "padding:12px 14px;border:1px solid #e6e6e6;border-radius:14px;" +
      "background:#fff;box-shadow:0 10px 30px rgba(0,0,0,.12);";

    bar.innerHTML = `
      <div style="font-weight:800;">
        Compare: <span id="bh-compare-count">0</span> selected
        <span style="opacity:.6;font-weight:700;">(max ${MAX})</span>
      </div>
      <div style="display:flex;gap:10px;align-items:center;">
        <button id="bh-compare-clear" type="button"
          style="padding:10px 12px;border-radius:12px;border:1px solid #ddd;background:#fff;font-weight:800;cursor:pointer;">
          Clear
        </button>
        <a id="bh-compare-go"
          href="${COMPARE_PATH}"
          style="padding:10px 14px;border-radius:12px;background:#111;color:#fff;text-decoration:none;font-weight:900;">
          Compare now
        </a>
      </div>
    `;

    document.body.appendChild(bar);

    qs("#bh-compare-clear", bar).addEventListener("click", () => {
      const empty = [];
      saveSelected(empty);
      syncCheckboxes(empty);
      renderBar(empty);
      setCompareLinkHref(empty);
      // If we are on compare page, apply immediately
      if (isComparePage()) applyCompareTableFilter();
    });

    return bar;
  }

  function renderBar(handles) {
    const bar = ensureBar();
    const count = handles.length;

    qs("#bh-compare-count", bar).textContent = String(count);

    const go = qs("#bh-compare-go", bar);
    go.setAttribute("href", buildCompareUrl(handles));

    bar.style.display = count ? "flex" : "none";
  }

  function onCheckboxChange(e) {
    const el = e.target;
    if (!el || !el.classList || !el.classList.contains("bh-compare-checkbox")) return;

    const handle = (el.getAttribute("data-bh-handle") || "").toLowerCase();
    let handles = loadSelected();

    if (el.checked) {
      const before = handles.length;
      handles = addHandle(handles, handle);

      if (handles.length === before) {
        el.checked = false;
        alert(`You can compare up to ${MAX} bikes.`);
        return;
      }
    } else {
      handles = removeHandle(handles, handle);
    }

    saveSelected(handles);
    syncCheckboxes(handles); // important: keep all cards consistent
    renderBar(handles);
    setCompareLinkHref(handles);
  }

  function hijackCompareLinks(e) {
    const a = e.target.closest && e.target.closest("a");
    if (!a) return;

    const href = a.getAttribute("href") || "";
    const isCompareLink = href === COMPARE_PATH || href.startsWith(COMPARE_PATH + "?");
    if (!isCompareLink) return;

    const handles = loadSelected();
    a.setAttribute("href", buildCompareUrl(handles));
  }

  function isComparePage() {
    return window.location && window.location.pathname === COMPARE_PATH;
  }

  function parseHandlesFromUrl() {
    try {
      const sp = new URLSearchParams(window.location.search || "");
      const raw = (sp.get("compare") || "").trim();
      if (!raw) return [];
      return raw
        .split(",")
        .map((x) => decodeURIComponent(String(x || "")).trim().toLowerCase())
        .filter(Boolean);
    } catch (e) {
      return [];
    }
  }

  // This is the key fix: hide/show columns client-side on compare page
  function applyCompareTableFilter() {
    if (!isComparePage()) return;

    const allCols = qsa('[data-cmp-handle]');
    if (!allCols.length) return;

    const selectedFromUrl = parseHandlesFromUrl();
    let selected = selectedFromUrl.length ? selectedFromUrl : [];

    // Fallback: if no compare= in URL, show items with data-cmp-visible="1"
    if (!selected.length) {
      const visible = qsa('[data-cmp-handle][data-cmp-visible="1"]').map((el) =>
        (el.getAttribute("data-cmp-handle") || "").toLowerCase()
      );
      selected = Array.from(new Set(visible)).filter(Boolean);
    }

    const selectedSet = new Set(selected);

    // Hide or show each column cell
    let shownCount = 0;
    allCols.forEach((el) => {
      const h = (el.getAttribute("data-cmp-handle") || "").toLowerCase();
      const show = selectedSet.has(h);
      if (show) shownCount += 1;
      el.classList.toggle("cmp-hidden", !show);
    });

    // Empty state message
    const empty = qs("#cmp-empty");
    const table = qs("#cmp-table");
    if (empty && table) {
      const hasAny = shownCount > 0;
      empty.style.display = hasAny ? "none" : "block";
      table.style.display = hasAny ? "table" : "none";
    }
  }

  function init() {
    const handles = loadSelected();

    syncCheckboxes(handles);
    renderBar(handles);
    setCompareLinkHref(handles);

    document.addEventListener("change", onCheckboxChange);
    document.addEventListener("click", hijackCompareLinks, true);

    // Apply compare filter on compare page
    applyCompareTableFilter();

    document.addEventListener("shopify:section:load", () => {
      const h = loadSelected();
      syncCheckboxes(h);
      renderBar(h);
      setCompareLinkHref(h);
      applyCompareTableFilter();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
